var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9361 12.26L14.3961 11.97C13.7861 11.9 13.1861 12.11 12.7561 12.54L10.9161 14.38C8.0861 12.94 5.7661 10.63 4.3261 7.79001L6.1761 5.94001C6.6061 5.51001 6.8161 4.91001 6.7461 4.30001L6.4561 1.78001C6.3361 0.77001 5.4861 0.0100098 4.4661 0.0100098H2.7361C1.6061 0.0100098 0.666095 0.95001 0.736095 2.08001C1.2661 10.62 8.0961 17.44 16.6261 17.97C17.7561 18.04 18.6961 17.1 18.6961 15.97V14.24C18.7061 13.23 17.9461 12.38 16.9361 12.26Z",
    fill: "#27BAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a1cad3a38acbdce8f88f13e5261d99f6.svg";
export { ForwardRef as ReactComponent };